import LibraryModel from '../Apis/Library'
import Controller from './Controller'

export default class LibraryController extends Controller {
  constructor() {
    super(new LibraryModel())
  }
  async search() {
    const response = await this.model.search( )
   return response.libraries
 }
}
